import React from 'react';
import { useProducts } from '../../common/hooks/useProducts';
import { useProducer } from '../../common/hooks/useProducer';
import Card from '../../common/components/Card';
import Loading from '../../common/components/Loading';
import './DashboardScreen.css';

const DashboardScreen = () => {
  const { profile, isLoading: producerLoading } = useProducer();
  const { products, isLoading: productsLoading } = useProducts();

  if (producerLoading || productsLoading) {
    return <Loading message="Loading dashboard..." />;
  }

  const activeProducts = products?.filter(p => p.is_active) || [];
  const totalProducts = products?.length || 0;

  return (
    <div className="dashboard-screen">
      <div className="dashboard-header">
        <h1>Welcome back, {profile?.farm_name || 'Producer'}!</h1>
        <p>Here's an overview of your stock</p>
      </div>

      <div className="dashboard-stats">
        <Card className="stat-card">
          <div className="stat-value">{totalProducts}</div>
          <div className="stat-label">Total Products</div>
        </Card>
        <Card className="stat-card">
          <div className="stat-value">{activeProducts.length}</div>
          <div className="stat-label">Active Products</div>
        </Card>
        <Card className="stat-card">
          <div className="stat-value">{totalProducts - activeProducts.length}</div>
          <div className="stat-label">Inactive Products</div>
        </Card>
      </div>

      <div className="dashboard-quick-links">
        <h2>Quick Actions</h2>
        <div className="quick-links-grid">
          <a href={`/${profile.url_friendly_name}/farm-details`} className="quick-link-card">
            <h3>Farm Details</h3>
            <p>Edit your farm information and location</p>
          </a>
          <a href={`/${profile.url_friendly_name}/products`} className="quick-link-card">
            <h3>Manage Products</h3>
            <p>Add, edit, or remove products from your catalog</p>
          </a>
          <a href={`/${profile.url_friendly_name}/stock`} className="quick-link-card">
            <h3>Update Stock</h3>
            <p>Manage pricing and inventory levels</p>
          </a>
          <a href={`/${profile.url_friendly_name}/orders`} className="quick-link-card">
            <h3>View Orders</h3>
            <p>Manage customer orders and fulfillment</p>
          </a>
        </div>
      </div>

      {products && products.length > 0 && (
        <div className="recent-products">
          <h2>Recent Products</h2>
          <div className="products-grid">
            {products.slice(0, 4).map((product) => (
              <Card key={product.id} className="product-card">
                <h3>{product.name}</h3>
                <p className="product-category">{product.category || 'Uncategorized'}</p>
                <p className="product-size-type">Size type: {product.size_type_name}</p>
                <span className={`product-status ${product.is_active ? 'active' : 'inactive'}`}>
                  {product.is_active ? 'Active' : 'Inactive'}
                </span>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardScreen;
